import { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { COOKIE_CALLBACK_NUMBER } from 'constants/env';
import {
    StyledActionButton,
    StyledActions,
    StyledDialog,
    StyledDialogContent,
    StyledOverlay,
} from 'containers/OTP/Style';
import { AppContext } from 'store/AppContext';
import { deleteCookie, extractParams } from 'utils/common/common';

function Popup() {
    const {
        setFilterNonurgent,
        userData,
        wmaAllowed,
        hidePopup,
        setHidePopup,
    } = useContext(AppContext);
    const { partner } = userData;
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { partnerId, requestId } = extractParams(pathname);
    const { t } = useTranslation();

    const onProceed = () => {
        setHidePopup(true);
        setFilterNonurgent(true);
        navigate(`/${partnerId}${requestId ? `/${requestId}` : ''}/wma-map`);
    };

    const onExit = () => {
        setHidePopup(true);
        deleteCookie(COOKIE_CALLBACK_NUMBER);
        navigate(`/${partnerId}${requestId ? `/${requestId}` : ''}/home`);
    };

    return (
        <>
            {!hidePopup && (
                <StyledOverlay>
                    <StyledDialog>
                        <StyledDialogContent>
                            {wmaAllowed.textKey ? t(wmaAllowed.textKey) : ''}
                        </StyledDialogContent>
                        <StyledActions>
                            {wmaAllowed.showProceedButton && (
                                <StyledActionButton onClick={onProceed}>
                                    {t('PROCEED')}
                                </StyledActionButton>
                            )}
                            {wmaAllowed.showExitButton && (
                                <StyledActionButton onClick={onExit}>
                                    {t('EXIT')}
                                </StyledActionButton>
                            )}
                        </StyledActions>
                    </StyledDialog>
                </StyledOverlay>
            )}
        </>
    );
}

export default Popup;
